/**
 * Format bytes to human readable format
 */

export function formatBytes(bytes: number, decimals: number = 2, t?: (key: string) => string): string {
  if (bytes === 0) return `0 ${t ? t('common.bytes') : 'Bytes'}`;
  
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizeKeys = ['common.bytes', 'common.kb', 'common.mb', 'common.gb', 'common.tb'];
  const sizesDefault = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const unit = t ? t(sizeKeys[i]) : sizesDefault[i];
  
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + unit;
}

export function formatBytesToMB(bytes: number, decimals: number = 2, t?: (key: string) => string): string {
  const unit = t ? t('common.mb') : 'MB';
  return (bytes / (1024 * 1024)).toFixed(decimals) + ' ' + unit;
}

export function formatBytesToKB(bytes: number, decimals: number = 2, t?: (key: string) => string): string {
  const unit = t ? t('common.kb') : 'KB';
  return (bytes / 1024).toFixed(decimals) + ' ' + unit;
}
